export const fmt = {
    text: (t) => (t && String(t).trim().length ? t : "—"),
};
